export default "/images/vendor/@coreui/icons/svg/flag/cif-ss.svg?dc632620ef4d76694e922428c1f0cd39";